
import { Component, Vue } from "vue-property-decorator";

import { Logger } from "@/utils/Logger";
import { LicencesNationalesBadRequestApiError } from "@/core/service/licencesnationales/exception/LicencesNationalesBadRequestApiError";
import { rulesForms } from "@/core/RulesForm";
import { Message, MessageType } from "@/core/CommonDefinition";
import MessageBox from "@/components/common/MessageBox.vue";

@Component({ components: { MessageBox } })
export default class FormLogin extends Vue {
  rulesForms: any = rulesForms;
  siren: string = "";
  password: string = "";
  buttonLoading: boolean = false;
  isValid: boolean = false;
  show: boolean = false;
  creationCompteEffectuee: boolean = false;

  validate(): void {
    this.$store.dispatch("closeDisplayedMessage");
    this.isValid = !!(
      (this.$refs.login as Vue & { valid: () => boolean }).valid &&
      (this.$refs.password as Vue & { valid: () => boolean }).valid
    );
    if (this.isValid) {
      this.login();
    }
  }

  login(): void {
    this.buttonLoading = true;
    this.$store.dispatch("closeDisplayedMessage");

    this.$store
      .dispatch("login", { login: this.siren, password: this.password })
      .catch(err => {
        Logger.error(err.toString());
        const message: Message = new Message();
        message.type = MessageType.ERREUR;
        if (err instanceof LicencesNationalesBadRequestApiError) {
          message.texte = err.message;
        } else {
          message.texte = "Impossible d'exécuter l'action : " + err.message;
        }
        message.isSticky = true;

        this.$store.dispatch("openDisplayedMessage", message).catch(err => {
          Logger.error(err.toString());
        });
      })
      .finally(() => {
        this.buttonLoading = false;
      });
  }

  afficherMotDePasseOulie(): void {
    this.$emit("onChange"); // On notifie le composant parent
  }
}
